import React, { FC, PropsWithChildren } from 'react';

import clsx from 'clsx';

import styles from './BadgeCount.module.scss';

type ClassKey = 'root' | 'count';

type BadgeCountProps = {
    count: string;
    isShowCount?: boolean;
    classes?: Classes<ClassKey>;
};
export const BadgeCount: FC<PropsWithChildren<BadgeCountProps>> = (props) => {
    const { count, children, classes, isShowCount = true } = props;

    return (
        <div className={clsx(styles.root, classes?.root)}>
            {isShowCount && <span className={clsx(styles.count, classes?.count)}>{count}</span>}
            {children}
        </div>
    );
};
